import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Paper, Box, Typography } from '@mui/material';

const AreaChartComponent = () => {
  const chartOptions = {
    chart: {
      type: 'area',
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo:0.5,
        stops: [100, 90, 100],
      },
    },
    tooltip: {
      x: { format: 'MMM' },
    },
    xaxis: {
      categories: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ],
      labels: {
        style: { fontSize: '12px', color: '#6B7280' }
      }
    },
    yaxis: {
      labels: {
        style: { fontSize: '12px', color: '#6B7280' }
      }
    },
    colors: ['#0461EA'],
  };

  const chartSeries = [
    {
      name: 'Universities',
      data: [20, 25, 30, 35, 40, 50, 60, 70, 90, 100, 110, 120],
    },
  ];

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="subtitle2" sx={{ color: '#6B7280', mb: 0.5 }}>
        Total Universities
      </Typography>
      <Typography variant="h5" fontWeight={600} sx={{ color: '#1B2028', mb: 2 }}>
        120{' '}
        <span style={{ fontSize: '14px', color: '#0461EA', fontWeight: 500 }}>
          +5%
        </span>
      </Typography>
      <Box>
        <ReactApexChart
          options={chartOptions}
          series={chartSeries}
          type="area"
          height={280}
        />
      </Box>
    </Paper>
  );
};

export default AreaChartComponent;
